import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { ServerUnreachable } from 'components/ServerUnreachable';
import { useAuth } from 'contexts/AuthContext';
import { isTotadminUser } from 'utils/auth';

export function AuthGuard({ children }: { children: ReactNode }): ReactNode {
    const { user, loading, unreachable, retry } = useAuth();
    const location = useLocation();

    if (loading) return null;

    // L'API n'a pas répondu : on ne sait pas si la session est valide, donc on ne tranche pas.
    // Rediriger vers /login ici reviendrait à annoncer une déconnexion qui n'a pas eu lieu.
    if (unreachable) return <ServerUnreachable onRetry={retry} />;

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!isTotadminUser(user)) {
        return <Navigate to="/login" replace />;
    }

    return children;
}
